import React from 'react';

import { Box } from '@mui/material';
import clsx from 'clsx';
import MedallionPreview from 'components/MedallionPreview';
import { WORKFLOW_PREVIEW_SCALE } from 'components/MedallionPreview/helper/constants';
import PropTypes from 'prop-types';
import { buildThemeConfig } from 'views/V2/Medallion/helper/utilities';

import styles from './workflowThemePreview.module.css';

const WorkflowThemePreview = ({
    workflowData,
    theme,
    logo,
    screens,
    previewScreens = 2,
    className = '',
}) => {
    const stored = workflowData?.verify_ui_config ?? {};

    return (
        <Box className={clsx(styles.previewBox, className)}>
            <MedallionPreview
                config={buildThemeConfig(theme ?? stored.theme)}
                logo={logo ?? stored.logo}
                screens={screens}
                scale={WORKFLOW_PREVIEW_SCALE}
                screenCount={previewScreens}
                className={styles.preview}
            />
        </Box>
    );
};

WorkflowThemePreview.propTypes = {
    previewScreens: PropTypes.number,
    workflowData: PropTypes.object,
    theme: PropTypes.object,
    logo: PropTypes.string,
    screens: PropTypes.array,
    className: PropTypes.string,
};

export default WorkflowThemePreview;
